import { DetailAction } from '../../detail/actions/DetailAction';
import { Backend } from '../../../api/Backend';
import { CmsFilterCallback, CmsFilterData } from './CmsFilterTypes';

export class ClearCmsFilterAction extends DetailAction {
  private filter: CmsFilterData;
  private _callback: CmsFilterCallback;
  constructor(backend: Backend, filter: CmsFilterData, callback: CmsFilterCallback) {
    super(backend);
    this.filter = filter;
    this._callback = callback;
  }

  override doAction() {
    this.filter.year = undefined;
    this.filter.rating = undefined;
    this.filter.category = undefined;
    this._callback(this.filter);
  }
}
